// @ts-nocheck
import type { Question } from '../types';

export const laneChangingQuestions: Question[] = [
  {
    id: 'q-lc-1',
    topic: 'General',
    question: 'You are on a road with a solid white line between your lane and the left lane. What does this mean?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/lane-changing/lane-changing-1-solid-white-line.png',
    options: [
      { id: 'q-lc-1o1', text: 'You may cross it to overtake when safe' },
      { id: 'q-lc-1o2', text: 'You must not cross this line except to avoid a hazard' },
      { id: 'q-lc-1o3', text: 'You may cross it freely at any time' }
    ],
    answerId: 'q-lc-1o2',
    explanation: 'A solid white line marks the edge of a lane and prohibits crossing except when necessary to avoid a hazard or obstruction. Do not change lanes across a solid white line unless it is essential for safety. (RVV 1990 art. 64)',
    subject: 'Lane Changing',
    animationId: null,
  },
  {
    id: 'q-lc-2',
    topic: 'General',
    question: 'You are on a road with a dashed white line between your lane and the next. What does this permit?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/lane-changing/lane-changing-2-dashed-white-line.png',
    options: [
      { id: 'q-lc-2o1', text: 'You must change lanes immediately' },
      { id: 'q-lc-2o2', text: 'You may change lanes when it is safe and you have checked your mirrors' },
      { id: 'q-lc-2o3', text: 'You must signal but do not need to check mirrors' }
    ],
    answerId: 'q-lc-2o2',
    explanation: 'A dashed white line permits lane changes when safe. You must still check mirrors, signal, and look over your shoulder to check for vehicles in your blind spot before changing lanes. (RVV 1990 art. 64)',
    subject: 'Lane Changing',
    animationId: null,
  },
  {
    id: 'q-lc-3',
    topic: 'General',
    question: 'What is the correct procedure for changing lanes safely?',
    options: [
      { id: 'q-lc-3o1', text: 'Check mirrors, signal, check blind spot, then change when safe' },
      { id: 'q-lc-3o2', text: 'Signal and change immediately' },
      { id: 'q-lc-3o3', text: 'Change lanes quickly without signaling' }
    ],
    answerId: 'q-lc-3o1',
    explanation: 'The correct Dutch CBR lane-changing procedure is: (1) check interior and side mirrors, (2) signal your intention, (3) check your blind spot by looking over your shoulder, and (4) change lanes smoothly when safe. This is the spiegel-teken-rijden sequence. (RVV 1990 art. 42, 43)',
    subject: 'Lane Changing',
    animationId: null,
  },
  {
    id: 'q-lc-4',
    topic: 'General',
    question: 'You want to change lanes in heavy rain. Why must you take extra care?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/lane-changing/lane-changing-4-heavy-rain.png',
    options: [
      { id: 'q-lc-4o1', text: 'Rain makes your mirrors clearer' },
      { id: 'q-lc-4o2', text: 'Reduced visibility and grip mean other vehicles are harder to see and braking is less effective' },
      { id: 'q-lc-4o3', text: 'Rain has no effect on lane changing' }
    ],
    answerId: 'q-lc-4o2',
    explanation: 'Heavy rain reduces visibility and road grip. Other vehicles are harder to spot, and both you and other drivers have reduced braking performance. Increase your following distance, check more carefully before changing lanes, and do not make sudden movements. (RVV 1990 art. 10)',
    subject: 'Lane Changing',
    animationId: null,
  },
  {
    id: 'q-lc-5',
    topic: 'General',
    question: 'You are driving at night and want to change lanes. What extra precaution should you take?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/lane-changing/lane-changing-5-night-driving.png',
    options: [
      { id: 'q-lc-5o1', text: 'Flash your lights instead of using mirrors' },
      { id: 'q-lc-5o2', text: 'Change lanes more quickly to minimize time in the other lane' },
      { id: 'q-lc-5o3', text: 'Check your blind spot more carefully — visibility is reduced and you may not see vehicles' }
    ],
    answerId: 'q-lc-5o3',
    explanation: 'At night, visibility is severely reduced. Your mirrors may not show all approaching vehicles, especially unlit motorcycles or bicycles. Check your blind spot more thoroughly by looking over your shoulder. Use dipped headlights to avoid dazzling other drivers. (RVV 1990 art. 66)',
    subject: 'Lane Changing',
    animationId: null,
  },
  {
    id: 'q-lc-6',
    topic: 'General',
    question: 'Before changing lanes, you check your mirror but see nothing. Is it safe to change lanes?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/lane-changing/lane-changing-6-blind-spot-danger.png',
    options: [
      { id: 'q-lc-6o1', text: 'Yes, mirrors show everything' },
      { id: 'q-lc-6o2', text: 'No — you must also check your blind spot by looking over your shoulder' },
      { id: 'q-lc-6o3', text: 'Only if the road is quiet' }
    ],
    answerId: 'q-lc-6o2',
    explanation: 'Mirrors do not show everything — there are areas beside and slightly behind your vehicle (blind spots) that mirrors cannot see. Before every lane change, physically check your blind spot by turning your head and looking over your shoulder. This is a legal requirement. (RVV 1990 art. 42)',
    subject: 'Lane Changing',
    animationId: null,
  },
  {
    id: 'q-lc-7',
    topic: 'General',
    question: 'You are behind a bus that is signaling to change lanes and merge. What should you do?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/lane-changing/lane-changing-7-bus-merge.png',
    options: [
      { id: 'q-lc-7o1', text: 'Speed up to pass before it moves' },
      { id: 'q-lc-7o2', text: 'Slow down and give way — allow the bus to merge safely' },
      { id: 'q-lc-7o3', text: 'Flash your lights to signal you will not move' }
    ],
    answerId: 'q-lc-7o2',
    explanation: 'When a bus signals to change lanes or merge from a stop, you should give way and allow it to move safely. Buses are large and need space; forcing them to wait creates hazards. Anticipate their movements and adjust your speed accordingly. (RVV 1990 art. 50)',
    subject: 'Lane Changing',
    animationId: null,
  },
  {
    id: 'q-lc-8',
    topic: 'General',
    question: 'Which mirrors must you check before changing lanes on a motorway?',
    options: [
      { id: 'q-lc-8o1', text: 'Only the side mirrors' },
      { id: 'q-lc-8o2', text: 'Interior mirror and side mirrors; also check your blind spot' },
      { id: 'q-lc-8o3', text: 'Mirrors are not needed if you check your blind spot' }
    ],
    answerId: 'q-lc-8o2',
    explanation: 'Always check your interior (rearview) mirror to see vehicles behind you, and both side mirrors to check the lane you plan to enter. Then physically check your blind spot by looking over your shoulder. This three-step check is essential before any lane change. (RVV 1990 art. 42)',
    subject: 'Lane Changing',
    animationId: null,
  },
  {
    id: 'q-lc-9',
    topic: 'General',
    question: 'What is the purpose of signaling before you change lanes?',
    options: [
      { id: 'q-lc-9o1', text: 'To make your car easier to see' },
      { id: 'q-lc-9o2', text: 'To warn other road users of your intention and give them time to react' },
      { id: 'q-lc-9o3', text: 'Signaling is optional if no one is nearby' }
    ],
    answerId: 'q-lc-9o2',
    explanation: 'Your signal informs other drivers and cyclists of your intention to change lanes, giving them time to react and allowing them to avoid collisions. Always signal your intention, even if you believe the road is clear — use your indicator lights. (RVV 1990 art. 42)',
    subject: 'Lane Changing',
    animationId: null,
  },
  {
    id: 'q-lc-10',
    topic: 'General',
    question: 'You see an oncoming vehicle in the lane you plan to enter. When may you change lanes?',
    options: [
      { id: 'q-lc-10o1', text: 'Immediately — you have right of way' },
      { id: 'q-lc-10o2', text: 'Wait until the oncoming vehicle has passed and the lane is completely clear' },
      { id: 'q-lc-10o3', text: 'Flash your lights to warn the other driver' }
    ],
    answerId: 'q-lc-10o2',
    explanation: 'You must wait until the lane is clear before changing. Never force your way into an occupied lane. The approaching vehicle has the right to use that lane. Wait, maintain your distance, and only change when it is absolutely safe to do so without forcing other road users to brake or swerve. (RVV 1990 art. 42, 43)',
    subject: 'Lane Changing',
    animationId: null,
  }
];
